import { api } from "@/api"
import { sleep } from "@/shared/utils"
import { Barrio } from "@/shared/types/barrio"
import { ReactNode } from "react";
import { QueryConfig, QueryResult } from "@/shared/types/base";
import { useQuery } from "@tanstack/react-query";


export async function checkBarrio(codigo:string): Promise<Barrio | null> {
    await sleep(1000);
    const { data } = await api.get("barrios/check/" + codigo);
    return data ? data : null;
}

export function useCheckBarrioQuery(codigo: string, queryConfig: QueryConfig<Barrio | null> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await checkBarrio(codigo),
        queryKey: ["barrios", "check", codigo],
    });
}

export interface CheckBarrioQueryProps {
    codigo: string;
    queryConfig?: QueryConfig<Barrio | null>;
    children?: (queryResult: QueryResult<Barrio | null>) => ReactNode;
}

export function CheckBarrioQuery({
    codigo,
    queryConfig,
    children
}: CheckBarrioQueryProps) {
    const queryResult = useCheckBarrioQuery(codigo, queryConfig);
    return children && children(queryResult);
}